import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"
import {Typography} from "@mui/material"
import Box from "@mui/material/Box"
import {FACETS_CONTAINER_OFFSET, FACETS_CONTAINER_MINIMUM_PADDING} from "../../../../config/constants"

interface FixedInfoContainerProps {
    top: number
    hide?: boolean
}

export const HFStyledClearAllContainer = styled("div")`
    display: flex;
    flex-grow: 1;
    flex: 1 0 80%;
    justify-content: flex-end;
    padding-bottom: 1.5rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    @media (min-width: ${breakpoints.values.md}px) {
        padding-left: 1rem;
        padding-right: 1rem;
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        flex: 1 0 75%;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        flex: 1 0 80%;
    }

    @media (max-width: ${breakpoints.values.lg - 1}px) {
        display: none;
    }
`

export const FilterFlexContainer = styled(Box)`
    min-width: 0;
    position: relative;
    display: none;

    @media (min-width: ${breakpoints.values.lg}px) {
        display: inherit;
        flex: 1 0 25%;
        z-index: 4;
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        flex: 1 0 25%;
    }
    @media (min-width: ${breakpoints.values.xl}px) {
        flex: 1 0 20%;
    }
`
export const FilterContainer = styled("div")`
    z-index: 1;
    margin-left: 1rem;
    width: calc(100% - 2rem);
    height: 100%;
`

export const FixedInfoContainer = styled("div")<FixedInfoContainerProps>`
    background: #ffffff;
    border-bottom: ${({theme}) => theme.colours.plp.facetDivider};
    min-height: 3.75rem;
    margin-bottom: 0.75rem;
    max-width: 13.400625rem;
    padding-top: 1.175rem;
    padding-bottom: 1rem;
    transform: translateY(-0.75rem);
    z-index: 2;

    ${({hide, theme, top}) => {
        if (hide) {
            return `
                display: none;
            `
        }

        return `
            margin-top: ${top}px;
            position: ${top > 0 ? "absolute" : "fixed"};
            width: ${top > 0 ? "100%" : "calc(20% - 2.5rem)"};
            @media (min-width: ${breakpoints.values.lg}px) {
                width: ${top > 0 ? "100%" : "calc(25% - 2.5rem)"};
            }
            @media (min-width: ${breakpoints.values.xl}px) {
                width: ${top > 0 ? "calc(100% - 2rem)" : "calc(20% - 2.5rem)"};
            }
        `
    }}
`

export const FiltersContainer = styled("div", {
    shouldForwardProp: p =>
        !["absoluteTop", "showFixedFacets", "hide", "isFiltersHidden", "totalProductsHeight"].includes(p as string),
})<{
    absoluteTop: number
    showFixedFacets: boolean
    hide?: boolean
    isFiltersHidden: boolean
    totalProductsHeight: number
}>`
    background: #ffffff;
    max-width: 13.400625rem;
    ${({hide, absoluteTop, theme, showFixedFacets, isFiltersHidden, totalProductsHeight}) => {
        if (hide) {
            return `
                padding-top: ${absoluteTop}px;
                position: relative;
                width: 100%;
            `
        }
        return `
            visibility: ${isFiltersHidden ? "hidden" : "unset"};
            padding-top: ${Math.max(
                absoluteTop > 0 && !showFixedFacets ? absoluteTop : totalProductsHeight + FACETS_CONTAINER_OFFSET,
                FACETS_CONTAINER_MINIMUM_PADDING,
            )}px;
            position: ${showFixedFacets ? "fixed" : "relative"};
            width: ${showFixedFacets ? "calc(20% - 2.5rem)" : "100%"};
            @media (min-width: ${breakpoints.values.lg}px) {
                width: ${showFixedFacets ? "calc(25% - 2.5rem)" : "100%"};
            }
            @media (min-width: ${breakpoints.values.xl}px) {
                width: ${showFixedFacets ? "calc(20% - 2.5rem)" : "100%"};
            }
        `
    }}
`

export const TotalProductsResult = styled("div")`
    display: flex;
    justify-content: space-between;
    transform: translateZ(0);
    position: relative;

    // extend the background without affecting the layout
    // fix for bug 35949
    &::before {
        content: "";
        background: #ffffff;
        display: block;
        top: -1rem;
        bottom: -1rem;
        left: 0;
        right: 0;
        position: absolute;
        z-index: -1;
    }
`

export const TotalProductsTitle = styled(Typography)<{component: "p"}>`
    white-space: nowrap;
`

export const ClearAllLink = styled("button")`
    color: ${({theme}) => theme.colours.text.hyperlink};
    background: none;
    border: none;
    padding: 0;
    text-decoration: none;
    font-size: 0.875rem;
    font-family: ${({theme}) => `${theme.colours.font.primary.medium.family}, ${theme.colours.font.default}`};
    font-weight: ${({theme}) => theme.colours.font.primary.medium.weight};
    line-height: 1.2;
    letter-spacing: 0.008rem;
    cursor: pointer;
    margin-left: 1rem;
    text-align: right;
    margin-top: 0.1875rem;

    [dir="rtl"] & {
        margin-left: 0;
        margin-right: 1rem;
        text-align: left;
    }

    &:hover {
        background: none;
        text-decoration: underline;
    }
`

type TotalRowProps = {
    totalRows: number
}

export const StyledNavListSecondRow = styled("div")<TotalRowProps>`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(calc(25% - 1px), 1fr));
    @media (min-width: ${breakpoints.values.lg}px) {
        grid-template-columns: repeat(auto-fill, minmax(calc(16.6666% - 1px), 1fr));
    }
    grid-gap: 1px;
    height: ${props => `calc(${props.totalRows} * 44px + 1px)`};
    margin-top: 1px;
`
